const MANAGE_PRODUCTION_CHECKS_URL_TEMPLATE =
  "https://manage.auth0.com/dashboard/{LOCALITY}/{TENANT}/production-checks";

export const buildManageProductionChecksUrl = ({ tenant, locality }) =>
  MANAGE_PRODUCTION_CHECKS_URL_TEMPLATE
    .replace("{LOCALITY}", locality)
    .replace("{TENANT}", tenant);
    